<template>
  <div id="contenedor-main-listado-expedientes-catalogo-documentos">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop
      :listadoExpedienteCatalogoDocumentos="listadoExpedienteCatalogoDocumentos">
      </desktop>
    </template>
    <template
      v-else>
      <desktop
      :listadoExpedienteCatalogoDocumentos="listadoExpedienteCatalogoDocumentos">
      </desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoExpedientesCatalogoDocumentos',
  props: {
    listadoExpedienteCatalogoDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
